import { Skeleton } from '@/components/ui/skeleton';
import React from 'react';

export const ViewControlsSkeleton: React.FC = () => {
  return (
    <div className="flex items-center justify-between gap-4 p-4 border-b border-border bg-card/50">
      <div className="flex items-center gap-2">
        <Skeleton className="h-9 w-24" />
      </div>

      <div className="flex items-center gap-2">
        <Skeleton className="h-4 w-16" />
        <Skeleton className="h-9 w-32" />
      </div>
    </div>
  );
}; 